import type { PrizeCard } from './types';

const HARDCODED_MYSTERY_PRIZES: PrizeCard[] = [
  { id: 'm1', title: 'ixxxxx', subtitle: 'Something exciting', mystery: true },
  {
    id: 'm2',
    title: 'Plxxxxxx',
    subtitle: 'Something exciting',
    mystery: true
  },
  {
    id: 'm3',
    title: 'Exxxxxxxx',
    subtitle: 'Something exciting',
    mystery: true
  },
  {
    id: 'm4',
    title: 'Mxxxxxxxxx',
    subtitle: 'Something exciting',
    mystery: true
  }
];

export default HARDCODED_MYSTERY_PRIZES;
